<template>
  <div class="cropper-modal">
    <div class="cropper-box">
      <div class="cropper-header">
        <h3>Crop Image</h3>
        <button class="btn btn-icon" @click="$emit('close')">
          <span class="icon-close"></span>
        </button>
      </div>

      <cropper ref="cropper" :src="src" :stencil-props="{ aspectRatio: aspect || null }"
        class="cropper-area" />

      <div class="cropper-actions">
        <button class="btn btn-secondary" @click="$emit('close')">Cancel</button>
        <button class="btn btn-primary" @click="applyCrop">Save Crop</button>
      </div>
    </div>
  </div>
</template>

<script>
import { Cropper } from "vue-advanced-cropper";
import "vue-advanced-cropper/dist/style.css";

export default {
  name: "NzCropperVueAdvanced",
  props: { src: String, aspect: Number },

  methods: {
    applyCrop() {
      const result = this.$refs.cropper.getResult();
      if (result?.canvas) {
        result.canvas.toBlob(blob => {
          this.$emit("cropped", blob);
        }, "image/jpeg", 0.9);
      }
    }
  },

  components: { Cropper }
};
</script>

<style scoped>
button.btn-icon{
  position: absolute;
  top: 12px;
  right: 12px;


}

.cropper-modal {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,.65);
  z-index: 9999999;
  display: flex;
  justify-content: center;
  align-items: center;
}
.cropper-box {
  position: relative;
  background: #fff;
  padding: 1.5rem;
  border-radius: 14px;
  width: 98%;
  height: 98%;

}
.cropper-area {
  height: 420px;
  background: #222;
  margin: 1rem 0;
}
.cropper-actions { display: flex;
  justify-content: space-between; }
</style>
